import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm, FormBuilder, Validators } from "@angular/forms";
import { SessionStorageService, LocalStorageService } from 'ngx-webstorage';
import { AppQueries, Dispatcher, GetInfoUser } from 'src/app/state';
import { ShortcutService } from "src/app/common/service/shortcut.service";
import { Subscription } from "rxjs";
import { EventManagerService } from "src/app/common/service/event-manager.service";
import { Constant } from "src/app/common/constant";
import { DialogService } from "src/app/common/service/dialog.service";
import { EditComponent } from "src/app/common/extend-code/edit.component";
import { UserProfile } from "src/app/common/models/users.model";
import { DateUtil } from "src/app/common/utils/date.util";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ProfileService } from "src/app/profile-user/profile-user.service";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "form-create-appointment",
  styleUrls: ['./form-create-appointment.component.scss'],
  templateUrl: "./form-create-appointment.component.html",
})

export class FormCreateAppointmentComponent extends EditComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isNoAuth: boolean = false;
  public editForm = this.fb.group({
    name: ['' , [Validators.required]],
    phone: ['', [Validators.required, Validators.pattern('[0-9]+')]],
    content: [''],
    hour: [0, [Validators.required]],
    minutes: [0, [Validators.required]],
    time: [null],
    date: ['' , [Validators.required]],
    email: ['', [Validators.pattern('^[_.A-Za-z0-9-]+@[_.A-Za-z0-9-]+[.]+[_.A-Za-z]+$')]],
    
  });
  public Constant = Constant;
  subscriptions?: Subscription[] = [];
  userProfile: UserProfile;
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManagerService,
    public profileService: ProfileService,
    private dialog: DialogService,
    public ngModal: NgbModal,
    public route: ActivatedRoute,
    public sessionStorageService: SessionStorageService,
    private dispatcher: Dispatcher,
    private appQueries: AppQueries) {
      super(eventManager, route);
  }

  ngOnInit() {
    this.subscriptions = [
      this.appQueries.userProfile$
      .subscribe((userProfile) => {
        this.userProfile = userProfile;
        this.detailObject = this.userProfile || new UserProfile();  
        this.updateForm();
      }),
      this.appQueries.sourceInfos$
      .subscribe((sourceInfos) => {
        if (!sourceInfos) {
          return;
        }
      }),
      this.editForm.get('date').valueChanges.subscribe(
        val => {
          this.disabledButton();
        }
      ),
      this.editForm.get('phone').valueChanges.subscribe(
        val => {
          this.disabledButton();
        }
      ),
    ];
    ShortcutService.addOneKey(13, this.save.bind(this));
  }
  ngOnDestroy() {
    ShortcutService.removeFuncEsc();
    this.eventManager.destroys(this.subscriptions);
  }
  ngAfterViewInit() {
    this.dialog.destroy();
  }
  updateForm() {
    this.editForm.patchValue({
      email: this.detailObject.email,
      phone: this.detailObject.phone,
      name: this.detailObject.name,
      content: '',
      hour: 0,
      minutes: 0,
      date: null,
    });
    this.isSaved = false;
  }
  disabledButton() {
    let hour = this.editForm.get('hour').value;
    if (hour < 0 || hour > 23) {
      this.errors.hour = true;
    } else this.errors.hour = false;
    let minutes = this.editForm.get('minutes').value;
    if (minutes < 0 || minutes > 59) {
      this.errors.minutes = true;
    } else this.errors.minutes = false;
    
    const date = this.editForm.get('date').value;
    const timeAt = DateUtil.revertDate(`${date}, ${hour < 10 ? '0' + hour : hour}:${minutes < 10 ? '0' + minutes : minutes}`, 'dd/MM/yyyy, hh:mm');
    if (date && hour && minutes && timeAt.getTime() < Date.now() + 1000 * 60 * 30 ) {
      this.errors.date = true;
    } else {
      this.errors.date = false;
    }
    this.editForm.patchValue({
      time: timeAt
    })
    const phone = this.editForm.value.phone || '';
    if (phone.length < 9) {
      this.errors.lengthPhone = true;
    } else {
      this.errors.lengthPhone = false;
    }
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }

  save() {
    this.isSaved = true;
    const result = this.disabledButton();
    if (result || this.editForm.invalid) {
      return;
    }
    const body = {
      name: (this.editForm.get('name').value || '').trim(),
      content: (this.editForm.get('content').value || '').trim(),
      email: (this.editForm.get('email').value || '').trim(),
      phone: (this.editForm.get('phone').value || '').trim(),
      timeAt: (this.editForm.get('time').value || new Date()).getTime()
    }
    const service = this.isNoAuth ? 'createAppointmentNoAuth' : 'createAppointment';
    return this.profileService[service](body)
    .subscribe(
      (res: any) => {
        if (this.isNoAuth) {
          this.updateForm();
        } else {
          this.dismiss();
        }
        setTimeout(() => {
          this.eventManager.broadcast({name: 'load-page'});
        }, 2000)
        this.dialog.showSuccess('Đặt lịch tư vấn thành công');
    })
  }
  dismiss() {
    this.ngModal.dismissAll();
  }
}
